import Menu from "ant-design-vue/es/menu";

const { Item, SubMenu } = Menu;
import { triggerWindowEvent } from "../../utils/util";
import { mapActions, mapGetters } from "vuex";
import { SHOW_MENU_FIELD } from "@/config/application";
export default {
  name: "SMenu",
  props: {
    theme: {
      type: String,
      required: false,
      default: "dark"
    },
    mode: {
      type: String,
      required: false,
      default: "inline"
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      openKeys: [],
      selectedKeys: [],
      cachedOpenKeys: []
    };
  },
  computed: {
    ...mapGetters(["usedRouter"]),
    rootSubmenuKeys: vm => {
      const keys = [];
      vm.usedRouter.forEach(item => keys.push(item.path));
      return keys;
    }
  },
  created() {
    this.event = triggerWindowEvent("clickMenu");
  },
  mounted() {
    this.updateMenu();
  },
  watch: {
    collapsed(val) {
      if (val) {
        this.cachedOpenKeys = this.openKeys.concat();
        this.openKeys = [];
      } else {
        this.openKeys = this.cachedOpenKeys;
      }
    },
    $route: function () {
      this.updateMenu();
    }
  },
  methods: {
    ...mapActions(["setAppTitle"]),
    clickMenuHandle(menu) {
      let eventMenu = menu;
      if (menu.meta.position && menu.meta.position.length === 1) {
        eventMenu = {
          ...menu,
          name: `${menu.name}$`
        };
      }
      this.event.menu = eventMenu;
      this.setAppTitle(menu.meta.title);
      window.dispatchEvent(this.event);
    },
    // select menu item
    onOpenChange(openKeys) {
      // 在水平模式下时执行，并且不再执行后续
      if (this.mode === "horizontal") {
        this.openKeys = openKeys;
        return;
      }
      // 非水平模式时
      const latestOpenKey = openKeys.find(key => !this.openKeys.includes(key));
      if (!this.rootSubmenuKeys.includes(latestOpenKey)) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    // 在刷新页面的时候根据路由来调整菜单
    updateMenu() {
      const routes = this.$route.matched.concat();
      const openKeys = [];
      this.selectedKeys = [routes.pop().path];
      if (this.mode === "inline") {
        routes.forEach(item => {
          openKeys.push(item.path);
        });
      }
      this.collapsed
        ? (this.cachedOpenKeys = openKeys)
        : (this.openKeys = openKeys);
    },
    // render
    renderItem(menu) {
      const isChildren = menu.children && menu.children.length > 0;
      if (menu.meta[SHOW_MENU_FIELD]) {
        return isChildren
          ? this.renderSubMenu(menu)
          : this.renderMenuItem(menu);
      }
      return null;
    },
    renderMenuItem(router) {
      const { clickMenuHandle } = this;
      // 菜单收缩时，因组件自身带有提示，不显示tooltip
      if (this.collapsed) {
        return (
          <Item
            {...{ key: router.path }}
            onClick={clickMenuHandle.bind(this, router)}
          >
            {/* <a-tooltip placement="right" title={router.meta.title}> */}
            <div>{router.meta.title}</div>
            {/* </a-tooltip> */}
          </Item>
        );
      } else {
        return (
          <Item
            {...{ key: router.path }}
            onClick={clickMenuHandle.bind(this, router)}
          >
            <a-tooltip placement="right" title={router.meta.title}>
              <div>{router.meta.title}</div>
            </a-tooltip>
          </Item>
        );
      }

    },
    renderSubMenu(router) {
      const itemArr = [];
      router.children.forEach(item => itemArr.push(this.renderItem(item)));
      //是否渲染icon {/* {this.renderIcon(menu.meta.icon)} */}
      if (this.collapsed) {
        return (
          <SubMenu {...{ key: router.path }}>
            <span slot="title">
              {/* <a-tooltip placement="right" title={router.meta.title}> */}
              <div>{router.meta.title}</div>
              {/* </a-tooltip> */}
            </span>
            {itemArr}
          </SubMenu>
        );
      } else {
        return (
          <SubMenu {...{ key: router.path }}>
            <span slot="title">
              <a-tooltip placement="right" title={router.meta.title}>
                <div>{router.meta.title}</div>
              </a-tooltip>
            </span>
            {itemArr}
          </SubMenu>
        );
      }
    }
    // 暂时不需要渲染icon
    // renderIcon (icon) {
    //   if (icon === 'none' || icon === undefined) {
    //     return null
    //   }
    //   const props = {}
    //   typeof (icon) === 'object' ? props.component = icon : props.type = icon
    //   return (
    //     <Icon {... { props } }/>
    //   )
    // }
  },

  render() {
    const { mode, theme, usedRouter } = this;
    const props = {
      mode: mode,
      theme: theme,
      openKeys: this.openKeys
    };
    const on = {
      select: obj => {
        this.selectedKeys = obj.selectedKeys;
        this.$emit("select", obj);
      },
      openChange: this.onOpenChange
    };

    const menuTree = usedRouter.map((item, index) => {
      if (index !== 0) {
        return this.renderItem(item);
      }
    });
    // {...{ props, on: on }}

    return (
      <Menu vModel={this.selectedKeys} {...{ props, on: on }}>
        {menuTree}
      </Menu>
    );
  }
};
